// extracted by mini-css-extract-plugin
export default {"container":"memeComments_container__lmVFw","containerMeme":"memeComments_containerMeme__7use2"};